module.exports = __webpack_public_path__ + "img/more-icon.c833d554.png";